module.exports = __webpack_public_path__ + "static-portal/img/custom-rj.f1b04a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-rj.jpg
// module id = qEuH
// module chunks = 4